module.exports = __webpack_public_path__ + "img/btn-key-active.eeebc4ae.svg";